import Link from "next/link";

export function Logo({ compact = false }: { compact?: boolean }) {
  return <Link className="brand" href="/" aria-label="Мыльница — главная"><span className="brand-mark">М</span><span><strong>Мыльница</strong>{!compact && <small>Всё для дома и заботы о себе</small>}</span></Link>;
}
